<script lang="ts">
  import Jumbo from '$components/Jumbo/Jumbo.svelte';
  import type ButtonI from '$interfaces/misc/button.interface';
  import { linkFromItem, strapiImage } from '$lib/utils';
  import tooltip from '@dantoo/dantools-svelte-components/src/actions/tooltip';
  import GenericTooltip from '@dantoo/dantools-svelte-components/src/components/GenericTooltip.svelte';

  import type { PageData } from './$types';
  import ItemList from '$components/pages/ItemList/ItemList.svelte';
  import listConfig from '$components/pages/ItemList/contents.config';
  import { browser } from '$app/environment';

  export let data: PageData;
  let { pageData, data: templateData } = data;
  $: ({ pageData, data: templateData } = data);

  $: collection = templateData.lootlist.collection;
</script>

<Jumbo
  config={{
    title: `${collection.name}`,
    text: `Below is a searchable list of all skins that are part of ${collection.name} in Counter-Strike 2.`,
    image: collection.image,
    imagePosition: 'right',
    buttons: templateData.agentCollections
      ? [
          {
            text: 'Most Expensive Agents',
            link: '/skins/agents/most-expensive',
            icon: 'face-tongue-money',
          },
          {
            text: 'Cheapest Agents',
            link: '/skins/agents/cheapest',
            icon: 'coin',
          },
          {
            text: 'CT Agents',
            link: '/skins/agents/counter-terrorists',
            icon: '/assets/binds-generator/ct.png',
          },
          {
            text: 'T Agents',
            link: '/skins/agents/terrorists',
            icon: '/assets/binds-generator/t.png',
          },
          {
            text: 'Collections',
            properties: {
              dropdown: true,
              options: templateData.agentCollections.map((col) => ({
                text: col.name,
                icon: 'treasure-chest',
                link: `/skins/collections/${col.slug}`,
                count: `${col.lootlists[0].items.count} agents`,
                image: col.image,
              })),
            },
          },
          {
            text: 'All Agents',
            link: '/skins/agents',
            properties: { highlighted: true },
          },
        ]
      : null,
  }}
>
  <div class="container-info" slot="inner_btn">
    {#if templateData.containers?.length}
      <span>Used in the following containers:</span>
      <ul class="container-list normalize">
        {#each templateData.containers as container}
          <li>
            <a
              href={linkFromItem({ ...container.item, container })}
              use:tooltip={{
                content: GenericTooltip,
                text: container.item.name,
                placement: 'bottom',
              }}
              aria-label={container.item.name}
            >
              <img src={strapiImage(container.item.image, 'thumbnail')} alt={container.item.name} />
            </a>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</Jumbo>
<div class="rw">
  <div class="cl cl-10">
    {#key templateData}
      <ItemList data={templateData} config={listConfig(templateData)} />
    {/key}
  </div>
</div>

<style lang="scss">
  :global(.splide) {
    width: 100%;
  }

  .container-info {
    display: flex;
    flex-direction: column;
    // align-items: center;
    gap: 1.5rem;

    & > span {
      text-transform: uppercase;
      letter-spacing: 1px;
      color: $col-light-5;
      font-size: 1rem;
      font-weight: 600;
      align-self: flex-start;

      background-color: rgba($col-primary, 0.1);
      color: $col-primary;
      padding: 0.4rem 1rem;
      border-radius: $radius;
      border: 1px solid rgba($col-primary, 0.05);

      @include respond(576) {
        align-self: center;
      }
    }
  }

  .container-list {
    display: flex;
    align-items: center;
    gap: $gutter;

    @include respond(576) {
      justify-content: center;
    }

    a {
      display: block;

      img {
        width: 4rem;
        display: block;
      }
    }
  }
</style>
